/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online bar chart maker. Paste your data as CSV or columns and get an instant, colourful bar or grouped-bar chart you can screenshot.`)
};

const es_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de barras online. Pega tus datos como CSV o columnas y obtén un gráfico de barras instantáneo y colorido, simple o agrupado, que puedes capturar.`)
};

const de_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Balkendiagramm-Ersteller. Fügen Sie Ihre Daten als CSV oder Spalten ein und erhalten Sie sofort ein farbenfrohes Balken- oder gruppiertes Balkendiagramm, das Sie als Screenshot festhalten können.`)
};

const nl_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online staafdiagrammaker. Plak je data als CSV of kolommen en krijg direct een kleurrijk staaf- of gegroepeerd-staafdiagram waarvan je een screenshot kunt maken.`)
};

const fr_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de graphique à barres en ligne. Collez vos données en CSV ou en colonnes et obtenez instantanément un graphique à barres coloré simple ou groupé que vous pouvez capturer.`)
};

const it_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a barre online. Incolla i tuoi dati come CSV o colonne e ottieni un grafico a barre istantaneo e colorato, singolo o raggruppato, che puoi catturare con uno screenshot.`)
};

const pt_br2_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de barras. Cole seus dados como CSV ou colunas e obtenha um gráfico de barras instantâneo e colorido, simples ou agrupado, que você pode capturar em screenshot.`)
};

const pt_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de barras online. Cole os seus dados em CSV ou colunas e obtenha instantaneamente um gráfico de barras ou de barras agrupadas colorido que pode capturar em ecrã.`)
};

const ja_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン棒グラフ作成ツール。データをCSVまたは列として貼り付けると、スクリーンショットに使える見やすい棒グラフやグループ化棒グラフが即座に得られます。`)
};

const zh_bar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线柱状图制作工具。将数据以 CSV 或列的形式粘贴，即可获得即时的多彩柱状图或分组柱状图，可截图使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_meta_description", locale)
	if (locale === "en") return en_bar_meta_description(inputs)
	if (locale === "es") return es_bar_meta_description(inputs)
	if (locale === "de") return de_bar_meta_description(inputs)
	if (locale === "nl") return nl_bar_meta_description(inputs)
	if (locale === "fr") return fr_bar_meta_description(inputs)
	if (locale === "it") return it_bar_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bar_meta_description(inputs)
	if (locale === "pt") return pt_bar_meta_description(inputs)
	if (locale === "ja") return ja_bar_meta_description(inputs)
	return zh_bar_meta_description(inputs)
};